import { createRequest } from '../../services/request';

export enum SPARE_PART_SUPPLIER_ACTION_TYPE {
  GET_SPARE_PART_SUPPLIER_BY_SELLER_ID = 'SPARE_PART_SUPPLIER/GET_SPARE_PART_SUPPLIER_BY_SELLER_ID',
}

export const GET_SPARE_PART_SUPPLIER_BY_SELLER_ID = createRequest(
  SPARE_PART_SUPPLIER_ACTION_TYPE.GET_SPARE_PART_SUPPLIER_BY_SELLER_ID,
);
